/*
 * Rychlé objednání — našeptávač pro B2B.
 *
 * Ordinace ví, co chce, a nechce to hledat v katalogu. Napíše název nebo
 * kód, vybere z nabídky, zadá množství a přidá. Bez odskoku na produkt.
 *
 * Vestavěnou sekci bulk-order z tématu Pharm nepoužíváme — váže se na
 * komponenty původní produktové sekce, které tenhle web nemá.
 */
(function () {
  'use strict';
  if (window._ilicoRychle) return;
  window._ilicoRychle = true;

  function kc(halere) {
    try {
      return new Intl.NumberFormat('cs-CZ', {
        style: 'currency', currency: 'CZK', maximumFractionDigits: 0
      }).format(halere / 100);
    } catch (e) {
      return Math.round(halere / 100) + ' Kč';
    }
  }

  function init(box) {
    var pole = box.querySelector('[data-rychle-hledat]');
    var vysledky = box.querySelector('[data-rychle-vysledky]');
    var hlaska = box.querySelector('[data-rychle-hlaska]');
    if (!pole || !vysledky) return;

    var timer = null;
    var posledni = '';

    function zprava(text, typ) {
      if (!hlaska) return;
      hlaska.textContent = text || '';
      hlaska.hidden = !text;
      hlaska.className = 'ilico-rychle__hlaska' + (typ ? ' is-' + typ : '');
    }

    function radek(p) {
      var li = document.createElement('li');
      li.className = 'ilico-rychle__polozka';

      var media = document.createElement('span');
      media.className = 'ilico-rychle__media';
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      li.appendChild(media);

      var info = document.createElement('span');
      info.className = 'ilico-rychle__info';
      var a = document.createElement('a');
      a.href = p.url;
      a.className = 'ilico-rychle__nazev';
      a.textContent = p.title;
      info.appendChild(a);
      li.appendChild(info);

      /* Vícevariantní produkt potřebuje výběr — jinak bychom přidali
         náhodnou velikost. */
      var vyber = document.createElement('select');
      vyber.className = 'ilico-rychle__varianta';
      vyber.setAttribute('aria-label', 'Varianta — ' + p.title);
      p.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = (v.title === 'Default Title' ? p.title : v.title)
          + ' · ' + kc(v.price) + (v.available ? '' : ' · není skladem');
        o.disabled = !v.available;
        vyber.appendChild(o);
      });
      if (p.variants.length > 1) li.appendChild(vyber);

      var mnozstvi = document.createElement('input');
      mnozstvi.type = 'number';
      mnozstvi.min = '1';
      mnozstvi.value = '1';
      mnozstvi.inputMode = 'numeric';
      mnozstvi.className = 'ilico-rychle__qty';
      mnozstvi.setAttribute('aria-label', 'Množství — ' + p.title);
      li.appendChild(mnozstvi);

      var cena = document.createElement('span');
      cena.className = 'ilico-rychle__cena';
      cena.textContent = kc(p.price);
      li.appendChild(cena);

      var pridat = document.createElement('button');
      pridat.type = 'button';
      pridat.className = 'ilico-rychle__pridat';
      pridat.textContent = 'Přidat';
      pridat.addEventListener('click', function () {
        var id = p.variants.length > 1 ? vyber.value : p.variants[0].id;
        var q = parseInt(mnozstvi.value, 10) || 1;
        pridat.disabled = true;
        pridat.textContent = '…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: q }] })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          pridat.textContent = '✓';
          pridat.classList.add('is-hotovo');
          zprava('Přidáno do košíku: ' + q + '× ' + p.title, 'ok');
          return window.ilicoKosik ? window.ilicoKosik.obnov() : null;
        }).catch(function () {
          pridat.disabled = false;
          pridat.textContent = 'Přidat';
          zprava('Položku se nepodařilo přidat — možná není skladem.', 'chyba');
        });
      });
      li.appendChild(pridat);

      return li;
    }

    function hledej(dotaz) {
      if (dotaz.length < 2) { vysledky.innerHTML = ''; return; }

      fetch('/search/suggest.json?q=' + encodeURIComponent(dotaz)
        + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
        { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var polozky = (d.resources && d.resources.results && d.resources.results.products) || [];
          vysledky.innerHTML = '';

          if (!polozky.length) {
            var li = document.createElement('li');
            li.className = 'ilico-rychle__nic';
            li.textContent = 'Nic jsme nenašli. Zkuste jiný název nebo nám zavolejte na 735 035 000.';
            vysledky.appendChild(li);
            return;
          }

          /* suggest.json nevrací varianty — musíme je dotáhnout zvlášť.
             URL z návrhů nese sledovací parametry (?_pos=…), takže „.js"
             se musí přilepit na čistou cestu — jinak přijde HTML místo
             JSON, parse spadne a řádek se tiše zahodí. */
          polozky.forEach(function (p) {
            fetch(p.url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (detail) {
                vysledky.appendChild(radek({
                  title: detail.title,
                  url: p.url,
                  price: detail.price,
                  featured_image: detail.featured_image,
                  variants: detail.variants
                }));
              })
              .catch(function () { /* jeden produkt nevyšel — ostatní ukážeme */ });
          });
        })
        .catch(function () {
          zprava('Vyhledávání se nepodařilo. Zkuste to prosím znovu.', 'chyba');
        });
    }

    pole.addEventListener('input', function () {
      var v = pole.value.trim();
      if (v === posledni) return;
      posledni = v;
      clearTimeout(timer);
      timer = setTimeout(function () { hledej(v); }, 250);
    });
  }

  function start() {
    document.querySelectorAll('[data-ilico-rychle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
